const bookBtns = document.querySelectorAll('.js-book')

const handleBooking = e => {
    e.preventDefault()

    Calendly.initPopupWidget({ url: 'https://calendly.com/thewallofbubbly?hide_landing_page_details=1&hide_gdpr_banner=1&background_color=eef3f1&text_color=222222&primary_color=3c6754' })
}

bookBtns.forEach(el => el.addEventListener('click', handleBooking))